import React from "react";
import { Select } from "@irati/ui/src/FormItem";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
export var WhoCanSeeCompanyBenefit;
(function (WhoCanSeeCompanyBenefit) {
    WhoCanSeeCompanyBenefit["Tenant"] = "tenant";
    WhoCanSeeCompanyBenefit["Team"] = "team";
})(WhoCanSeeCompanyBenefit || (WhoCanSeeCompanyBenefit = {}));
var options = function (formatMessage) { return [
    {
        value: WhoCanSeeCompanyBenefit.Tenant,
        label: formatMessage({ id: "admin.companyBenefits.whocansee.option.everyone" }, { tenantName: authentication.userTenant().public_name })
    },
    { value: WhoCanSeeCompanyBenefit.Team, label: formatMessage({ id: "admin.companyBenefits.whocansee.option.teams" }) }
]; };
var WhoCanSee = function (props) {
    var formatMessage = props.formatMessage;
    return (React.createElement(Select, { label: formatMessage({ id: "admin.companyBenefits.whocansee.label" }), options: options(formatMessage), value: props.value, isClearable: false, onChange: props.onChange }));
};
export default injectIntl(WhoCanSee);
